import { Badge, ArchiveSVG } from "@newsela/angelou";

export const ArchivedSidebarStatus = {
  icon: ArchiveSVG,
  text: "This class has been archived.",
  ariaProps: { "aria-label": "Archived" },
};

export const ArchivedBadgeStatus = () => (
  <Badge
    text="Archived"
    flavor={Badge.flavor.solid}
    color={Badge.color.grey}
    size={Badge.size.md}
    hideIcon
  />
);
